import swiper from "swiper";

if ($(".top-hero").length) {
  var hero = new swiper('.top-hero__bg', {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    effect: "fade",
    speed: 1200,
    slideToClickedSlide: false,
    allowTouchMove: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
}

if ($(".top-clinic-slider").length) {
  // const theWrapper = document.getElementById('swiperWrapper');
  var slider01 = new swiper(".top-clinic-slider", {
    loop: true,
    loopedSlides: 4,
    slidesPerView: "auto",
    spaceBetween: 10,
    speed: 10000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      // 960: {
      //   slidesPerView: 2
      // },
      768: {
        spaceBetween: 8,
      }
    },
  });
}
